import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { DashboardProvider } from "../context/DashboardContext";
import { FreqRangeProvider } from "../context/FreqRangeContext";
import { PowerGammaProvider } from "../context/PowerGammaContext";
import { useDashboardPresenceReport } from "../hooks/useDashboardPresenceReport";
import "../mobile.css";
import {
  DESKTOP_ONLY_TOPIC_IDS,
  MOBILE_TOPICS,
  pathToMobileTopic,
} from "../registry/mobileTopics";
import { TOPICS } from "../registry/topics";
import { MobileHeader } from "./MobileHeader";
import { MobileMainArea } from "./MobileMainArea";
import { MobileTabBar } from "./MobileTabBar";

function pathToTopic(pathname: string) {
  const match = TOPICS.find((t) => t.path === pathname);
  return match?.id ?? "dashboard";
}

function MobileShellInner() {
  const location = useLocation();
  const topicId = pathToMobileTopic(location.pathname);
  const fullTopic = pathToTopic(location.pathname);
  useDashboardPresenceReport(fullTopic, location.pathname);

  if (DESKTOP_ONLY_TOPIC_IDS.includes(fullTopic)) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="mobile-shell">
      <MobileHeader topicId={topicId} />
      <main className="mobile-shell__scroll">
        <MobileMainArea topicId={topicId} />
      </main>
      <MobileTabBar />
    </div>
  );
}

export function MobileShell() {
  useEffect(() => {
    document.body.classList.add("mobile-active");
    return () => document.body.classList.remove("mobile-active");
  }, []);

  return (
    <DashboardProvider>
      <PowerGammaProvider>
        <FreqRangeProvider>
            <Routes>
              {MOBILE_TOPICS.map((t) => (
                <Route key={t.id} path={t.path} element={<MobileShellInner />} />
              ))}
              <Route path="/florian" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </FreqRangeProvider>
      </PowerGammaProvider>
    </DashboardProvider>
  );
}
